var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1815 9.18027C13.1815 9.18027 9.93726 5.56201 9.93726 3.77314C9.93726 1.98423 11.3927 0.52887 13.1815 0.52887C14.9704 0.52887 16.4258 1.98427 16.4258 3.77314C16.4258 5.56201 13.1815 9.18027 13.1815 9.18027Z",
    fill: "white",
    stroke: "#8E9190",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2483 3.94782C14.3451 3.35846 13.9458 2.8022 13.3565 2.70539C12.7671 2.60858 12.2108 3.00787 12.114 3.59723C12.0172 4.18659 12.4165 4.74285 13.0059 4.83966C13.5952 4.93648 14.1515 4.53719 14.2483 3.94782Z",
    fill: "white",
    stroke: "#8E9190",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.81849 17.4712C4.81849 17.4712 1.57422 13.8529 1.57422 12.0641C1.57422 10.2752 3.02962 8.81979 4.81849 8.81979C6.6074 8.81979 8.06276 10.2752 8.06276 12.0641C8.06279 13.853 4.81849 17.4712 4.81849 17.4712Z",
    fill: "white",
    stroke: "#8E9190",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.58306 12.8287C6.00538 12.4064 6.00537 11.7217 5.58306 11.2994C5.16075 10.877 4.47604 10.877 4.05373 11.2994C3.63142 11.7217 3.63142 12.4064 4.05373 12.8287C4.47604 13.251 5.16075 13.251 5.58306 12.8287Z",
    fill: "white",
    stroke: "#8E9190",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.1817 9.18027H15.3179C15.9249 9.18027 16.417 9.67236 16.417 10.2794C16.417 10.8864 15.9249 11.3785 15.3179 11.3785H11.7609C10.8931 11.3785 10.1897 12.0819 10.1897 12.9497C10.1897 13.8174 10.8931 14.5209 11.7609 14.5209H13.0686C13.8833 14.5209 14.5437 15.1813 14.5437 15.996C14.5437 16.8108 13.8833 17.4712 13.0686 17.4712H4.8186",
    stroke: "#8E9190",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.a10c88cbb8747f97939be6267c16e556.svg";
export { ForwardRef as ReactComponent };